import React from 'react';
import './superxIndex.css'
import C2wSuperxLanding from '../../components/C2wSuperx/landing/landing';
import C2wSuperxJourney from '../../components/C2wSuperx/journey/journey';
import C2wSuperxBenefits from '../../components/C2wSuperx/benefits/benefits';
import C2wSuperxDomains from '../../components/C2wSuperx/domains/domains';
import C2wSuperxProjects from '../../components/C2wSuperx/projects/projects';
import C2wSuperxTestimonials from '../../components/C2wSuperx/testimonials/testimonials';
import C2wSuperxBatches from '../../components/C2wSuperx/batches/batches';
import Footer from './../c2wHomePage/Footer';
import C2wSuperxContentbar from '../../components/C2wSuperx/navbar/navbar';
import { Helmet } from 'react-helmet';

function C2wSuperxHome() {

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    console.log("Scroll Y Position:", scrollTop);
  });

  return (
    <div className='C2wSuperxHome_ctn'>
      <Helmet>
        {/* 
                    Purpose: Defines the page title displayed in search results and browser tabs. 
                             It’s one of the most important SEO elements. 
                    */}
        <title>{`Project Implementation Event`}</title>

        {/* 
                    Purpose: Provides a brief summary of the page content in search results. 
                             While not a direct ranking factor, it influences CTR. 
                    */}
        <meta name="description" content="" />

        {/* Purpose: Controls indexing and link-following behavior. */}
        <meta name="robots" content="index, follow" />

      </Helmet>
      {/* <C2wSuperxContentbar /> */}
      <C2wSuperxLanding />
      <C2wSuperxJourney />
      <C2wSuperxBenefits />
      {/* <C2wSuperxDomains />
      <C2wSuperxProjects /> */}
      {/* <C2wSuperxTestimonials />
      <C2wSuperxBatches /> */}
      <div className="ADfooter__container">
        <Footer /></div>
    </div>
  )
}

export default C2wSuperxHome
